import {
  ApiClientError,
  LocationACL,
  CreateResourceACLV5,
} from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useCreateResourceACLV5() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    LocationACL[],
    ApiClientError,
    { params: CreateResourceACLV5 }
  >(
    async ({ params }) => {
      const response = await raydiant.createResourceACLV5(params);
      return response;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(keys.library());
      },
    },
  );

  return mutation;
}
